import { Card } from '@mui/material';
import styled from 'styled-components';
import CommonShippingBasicInfo from '../../CommonShippingBasicInfo';

const MainWrap = styled(Card)`
  padding: 0.5rem;
  opacity: 0.95;
  .row{
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
`;

export default function RouteTooltip({ routeInfo }: { routeInfo: any }) {
  return (
    <MainWrap>
      <CommonShippingBasicInfo info={routeInfo} />
    </MainWrap>
  );
}
